import { MenuItem, InputLabel, Chip, Grid, FormHelperText } from '@material-ui/core';
import CropUploader from 'components/CropUploader';
import { Field } from 'formik';
import { agent } from 'helpers/agent';
import React, { Fragment, useEffect, useState } from 'react';
import { API_MYEDUZZ } from 'settings';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';

import { ETypes } from '../../classes/Product';

import type { Basic as BasicClass } from '../../classes/General';

interface IProps extends IForm<BasicClass> {}

function Basic(props: IProps) {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const listCategories = categories.map((item: any) => {
    return { label: item.name, value: item.id };
  });

  const fetchData = async () => {
    setIsLoading(true);
    const result = await agent.get(`${API_MYEDUZZ}/categories`);
    setCategories(result.data.data);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const { setFocus, getError, values, setFieldValue } = props;
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field label='Título do produto' name='title' id='title' onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field
            label='Tipo do produto'
            id='type'
            name='type'
            disabled
            options={[
              { label: 'InfoProduto', value: ETypes.DIGITAL },
              { label: 'Serviço', value: ETypes.SERVICE },
              { label: 'Físico', value: ETypes.PHYSICAL },
              { label: 'Ticket', value: ETypes.TICKET },
            ]}
            component={SelectFormField}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            label='Categorias'
            id='categories'
            name='categories'
            multiple
            options={listCategories}
            component={SelectFormField}
            renderValue={(selected: number[]) => (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {isLoading && <MenuItem>Carregando...</MenuItem>}
                {selected.map((categoryId: number) => {
                  const category = listCategories.find((item: any) => item.value === categoryId);
                  if (!category) return null;
                  return <Chip style={{ margin: '2px' }} key={`chip-${category.value}`} label={category.label} />;
                })}
              </div>
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Field label='Descrição do produto' name='description' id='description' multiline rows={6} onFocus={setFocus} component={TextFormField} />
        </Grid>
        <Grid item xs={12}>
          <InputLabel htmlFor='image_id' error={getError('image').error}>
            Imagem do produto
          </InputLabel>
          <CropUploader
            id='image_id'
            name='image_id'
            fileName='image_id'
            uploadType='cnt_foto'
            onChange={(field: string, value: string, img: string) => {
              setFieldValue(field, value);
              setFieldValue('image_url', img);
            }}
            image={values.image_url}
          />
          {getError('image') && <FormHelperText style={{ color: '#dc3f53' }}>{getError('image_id').helperText}</FormHelperText>}
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Basic;
